module.exports = __webpack_public_path__ + "img/ps8aziw38pafsxcpfj01w4lbcn8pgc9dz8o9ff9748c-a2fc-4a67-9ea2-9b4cbd5218e9.26402851.png";